/**
 * The calendar's views and their URL segments. Kept free of imports so `constant/routeURLs` can
 * build the routes from it without a cycle back through the page's own modules.
 */
export enum CALENDAR_VIEW {
  SEVEN_DAYS = 'SEVEN_DAYS',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export const CALENDAR_DATE_PARAM = 'date';

/** Each view is addressable, so a link or a bookmark can open one directly. */
export const CALENDAR_VIEW_PATH: Record<CALENDAR_VIEW, string> = {
  [CALENDAR_VIEW.SEVEN_DAYS]: '7-days',
  [CALENDAR_VIEW.WEEK]: 'week',
  [CALENDAR_VIEW.MONTH]: 'month',
};

const BY_PATH = new Map<string, CALENDAR_VIEW>(
  Object.entries(CALENDAR_VIEW_PATH).map(([ view, path ]) => [ path, view as CALENDAR_VIEW ])
);

/** The view a URL segment names, or undefined when it names none. */
export const calendarViewFromPath = (segment: string | undefined): CALENDAR_VIEW | undefined =>
  segment ? BY_PATH.get(segment.toLowerCase()) : undefined;
